import React, { useState } from 'react';
import { usePermission } from '../../../hooks/usePermission';
import { BSI_CSS } from './theme';
import BatchList from './BatchList';
import NewImport from './NewImport';
import BatchDetail from './BatchDetail';

/**
 * S3 Bulk Series Import — browse the approved S3 location, check what would be
 * imported, then import many series (or extra episodes for one series) in one
 * batch. Talks to /admin/v1/bulk-series-imports on cinema-admin-service.
 *
 * Flow: new import (type → folders) creates + checks a batch → batch page
 * previews it → start (production asks for a count confirmation) → the backend
 * worker transcodes in the background while the page refreshes itself →
 * retry failures (whole series or single episodes) → review the draft series.
 */
const BulkSeriesImport = () => {
    const { canEdit } = usePermission();
    const canManage = canEdit('bulk_series_import');

    const [view, setView] = useState('list'); // list | create | detail
    const [batchId, setBatchId] = useState(null);

    const openBatch = (id) => { setBatchId(id); setView('detail'); };

    return (
        <div className="content-page bsi-page">
            <style>{BSI_CSS}</style>
            {view === 'list' && <BatchList canManage={canManage} onOpen={openBatch} onNew={() => setView('create')} />}
            {view === 'create' && <NewImport onCancel={() => setView('list')} onCreated={openBatch} />}
            {view === 'detail' && (
                <BatchDetail key={batchId} batchId={batchId} canManage={canManage} onBack={() => setView('list')} />
            )}
        </div>
    );
};

export default BulkSeriesImport;
